import { createContext, useContext } from 'react'

const InspectionLoadingContext = createContext(null)

export function useInspectionLoading() {
  const context = useContext(InspectionLoadingContext)
  if (!context) {
    throw new Error('useInspectionLoading must be used within provider')
  }
  return context
}

export default InspectionLoadingContext
